import { render, staticRenderFns } from "./GoalsContainer.vue?vue&type=template&id=793fa612&scoped=true&"
import script from "./GoalsContainer.vue?vue&type=script&lang=js&"
export * from "./GoalsContainer.vue?vue&type=script&lang=js&"
import style0 from "./GoalsContainer.vue?vue&type=style&index=0&id=793fa612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793fa612",
  null
  
)

export default component.exports